module.exports = __webpack_public_path__ + "media/images/landing/en/save_time@2x-42ac6d312bfd0ba7ffa0dccaf9486daf.webp";